/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const enMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',
  'menu.online': 'Online',
  'menu.offline': 'Offline',
  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',


  /* 04.Dashboards */
  'dashboards.update': 'Update',
  'dashboards.save': 'Save',
  'dashboards.name': "Name",
  'dashboards.button': "Button",
  'dashboards.visits': "Visits",
  'dashboards.checkAvailability': "Check Availability or Rates",
  'dashboards.details': "Details",
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tickets',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'Ticket Count',
  'dashboards.commonticketsubmission': 'Common Ticket Submissions',
  'dashboards.category': 'Category',

  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Country',
  'dashboards.webVisitors': 'Web Visitors',
  'dashboards.avatarClicks': 'Avatar Clicks',
  'dashboards.wordCloud': 'Word Cloud',
  'dashboards.topic': 'Topic',
  'dashboards.roomsAvailability': 'Rooms & Availability',
  'dashboards.startChat': 'Start a Chat',
  'dashboards.restaurantsBars': 'Restaurants & Bars',
  'dashboards.groupBooking': 'Group Booking',
  'dashboards.promotions': 'Promotions',
  'dashboards.weedingevents': 'Wedding & Events',
  'dashboards.lostsomething': 'Lost Something',
  'dashboards.producttext': 'Product Text',
  'dashboards.bookingroomnew': 'Booking Room New',
  'dashboards.email': 'Email',
  'dashboards.phone': 'Phone',
  'dashboards.zipcode': 'Zip Code',
  'dashboards.marketingconsent': 'Marketing Consent',
  'dashboards.additionalinfo': 'Additional Info',
  'dashboards.viewallcontacts': 'View All Contacts',
  'dashboards.current': 'Current',
  'dashboards.last7days': 'Last 7 Days',
  'dashboards.last30days': 'Last 30 Days',
  'dashboards.thisweek': 'This Week',
  'dashboards.thismonth': 'This Month',
  'dashboards.previousmonth': 'Previous Month',
  'dashboards.yeartodate': 'Year to Date',
  'dashboards.lastyear': 'Last Year',
  'dashboards.all': 'All',
  'dashboards.standardOccupancy': 'Standard Occupancy',
  'dashboards.max-occupancy': 'Max Occupancy',
  'dashboards.numberOfThisType': 'Number of this Type',
  'dashboards.displayOrder': 'Display Order',
  'dashboards.provider': 'Provider',
  'dashboards.edit': 'Edit',
  'dashboards.delete': 'Delete',
  'dashboards.addImages': 'Add Images',
  'dashboards.near': 'Near',
  'dashboards.calling_party': 'Calling Party User',
  'dashboards.called_party': 'Called Party User',
  'dashboards.lastdial': 'Last Dial',
  'dashboards.imagelink': 'Image Link',
  'dashboards.browsegallery': 'Browse Gallery',
  'dashboards.changelog': 'Change Log',
  'dashboards.externalresources': 'External Resources',
  'dashboards.webpage': 'Web Page',
  'dashboards.web-pages': 'Web Pages',
  'dashboards.published': 'Published',
  'dashboards.adddocument': 'Add Document',
  'dashboards.ready-to-publish': 'Ready to Publish',
  'dashboards.draft': 'Draft',
  'dashboards.order-by': 'Order By',
  'dashboards.add-faq': 'Add FAQ',
  'dashboards.collections': 'Collections',

  'dashboards.items': 'Items',
  'dashboards.rooms-availability': 'Rooms & Availability',
  'dashboards.events-wedding-venues': 'Events & Wedding Venues',
  'dashboards.long-stay-enquiry': 'Long Stay Enquiry',
  'dashboards.reservation-confirmation-request': 'Reservation Confirmation Request',
  'dashboards.modify-cancel-booking': 'Modify or Cancel Booking',
  'dashboards.left-something-behind': 'Left Something Behind',
  'dashboards.invoice-copy': 'Invoice/Receipt Copy',
  'dashboards.sync': 'Sync',
  'dashboards.add-web-page': 'Add Web Page',
  'dashboards.sprint-title': 'Meet Sprint, our breakthrough automation to train AI Model in 10× less time.',
  'dashboards.sprint-description': 'Sprint works alongside you—to unleash creativity, unlock productivity, and drastically reduce the time it takes to train the Digital Assistant.',
  'dashboards.sprint-feature': 'The Sprint feature is designed to sync knowledge from external sources, making it valuable for both initial setup and ongoing data updates. When executed on an active system, Sprint modifies the Knowledge Hub based on your configured external sources, which can directly influence AI-generated behaviours and responses. For assistance with Sprint setup, please contact our support team.',
  'dashboards.change-password': 'Change Password',
  'dashboards.sign-out': 'Sign Out',
  'dashboards.privacy-policy': 'Privacy Policy',
  'dashboards.help-center': 'Help Center',
  'dashboards.switch-account': 'Switch Account',
  'dashboards.business-settings': 'Business Settings',
  'dashboards.notifications-allowed': 'Notifications Allowed',
  'dashboards.dark-theme': 'Dark Theme',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Invoice & Payments',
  'dashboards.upgrade-plan': 'Upgrade Plan',
  'dashboards.add-room': 'Add Room',
  'dashboards.room-type': 'Room Type',
  'dashboards.room-name': 'Room Name',
  'dashboards.how-many-guests': 'How many guests can stay in this room?',
  'dashboards.number-of-rooms-this-type': 'Number of rooms (of this type)',
  'dashboards.number-of-bedrooms': 'Number of bedrooms',
  'dashboards.number-of-livingrooms': 'Number of living rooms',
  'dashboards.minimum-adults': 'Minimum Adults',
  'dashboards.maximum-adults': 'Maximum Adults',
  'dashboards.maximum-children': 'Maximum Children',
  'dashboards.maximum-infants': 'Maximum Infants',
  'dashboards.extra-beds-allowed': 'Extra Beds Allowed',
  'dashboards.booking-engine-code': 'Booking Engine Code',
  'dashboards.room-size': 'Room Size',
  'dashboards.balcony-area': 'Balcony Area',
  'dashboards.unit': 'Unit',
  'dashboard.whatsapp_message': 'Type your message here...',
  'dashboard.whatsapp_reply_window': 'You have a 24-hour window to reply to a customer message on WhatsApp Business from the time the customer last messaged you. If you send a reply within this 24-hour \"customer care window,\" you can send any message type. After the 24-hour window closes, you can only send messages using pre-approved Message Templates, which restart the 24-hour window when the customer responds.',
  'dashboards.square-meters': 'Square Meters',
  'dashboard.pick_quick_reply': 'Pick a quick reply or type your message',
  'dashboard.hang_in_there': 'Hang in there while we try to connect you!',
  'dashboard.outbound_msg': 'When to send the outbound message',
  'dashboard.message_sent': 'Your message has been sent successfully!',
  'dashboard.failed_msg': 'Failed to send message',
  'dashboard.new_chat_message': 'New chat message',
  'dashboard.user_msg': ' There is a user message in the last 24 hours, you can send any messages as a reply, Do you still want to send this template message or reply with any message?',
  'dashboard.us_number': ' WhatsApp business messages are not being sent to U.S. numbers because Meta paused all marketing messages to U.S. numbers on April 1, 2025.',
  "dashboard.error_msg": "Please complete all placeholders correctly.",

  'web-widget.title': 'Web Widget Menus for the Website Chatbot',
  /* Home Page */
  'dashboards.quickstartwithai': 'Quick Start with AI',
  'dashboards.fastestpathtoautomation': "You're on the fastest path to automation with AI tools",
  'dashboards.insightsthatempower': 'Insights that Empower',
  'dashboards.trainchatbot': 'Train Chatbot',
  'dashboards.automatewithforms': 'Automate with Forms',
  'dashboards.inroomdigitalcompendium': 'In-Room Digital Compendium',
  'dashboards.support': 'Support',
  'dashboards.helpcenter': 'Help Center',
  'dashboards.searchfaqintegrations': 'Search for articles about common FAQ’s, integrations and more.',
  'dashboards.asklivechat': 'Ask question to our team on Live Chat',
  'dashboards.inroomqrcode': 'In‑room QR code to see information about the property and location',
  'dashboards.customizewebwidget': 'Customize and add Web Widget to your website with an integrated AI Chatbot',
  'dashboards.createcustomforms': 'Create custom forms and get notifications when guest submits a form',
  'dashboards.trainchatbotproperty': 'Train Chatbot with information about your property like check in time, activities etc',
  'dashboards.chatbotinsights': 'See how your Chatbot is engaging the guests and gain insights into stats like website visitors, commonly asked questions, and much more.',
  'dashboards.addaichatbottoyourwebsite': 'Add AI Chatbot to your Website',

  /* Email Stats  */
  'dashboards.thread-summary-title': 'Thread Summaries',
  'dashboards.thread-summary-subtitle': 'Email summaries generated by AI',
  'dashboards.ai-replies-title': 'AI Replies',
  'dashboards.ai-replies-subtitle': 'Replies generated by AI',

  'dashboards.total-thread-summary-title': 'Total Thread Summaries Generated',
  'dashboards.total-ai-replies-title': 'Total AI Replies Generated',
  'dashboards.total-draft-copied': 'Draft Copied by Users',

  'dashboards.urgency': 'Urgency',
  'dashboards.sentiment': 'Sentiment',

  'dashboards.common-email-reasons': 'Common Email Reasons',
  'dashboards.topics-in-emails': 'Topics in emails',

  'dashboards.email-assistant-usage': 'AI Email Assistant Usage',
  'dashboards.usage-by-email-address': 'Usage by email addresses',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  "property-info.allcustomers": 'All Customers',
  'property-info.external-sources': 'External Sources',
  'property-info.faq': 'FAQs',
  'property-info.documents': 'Documents',
  'property-info.publish-ai': 'Publish AI',
  'property-info.pre-built-templates': 'Pre-Built Templates',
  'property-info.room-types': 'Room Types',
  'property-info.about-property': 'About Property',
  'property-info.about-properties': 'About Properties',
  'property-info.facilities-services': 'Facilities & Services',
  'property-info.property-facilities': 'Property Facilities',
  'property-info.room-amenities': 'Room Amenities',
  'property-info.property-contact': 'Property Contact',
  'property-info.property-activities': 'Property Activities',
  'property-info.property-location': 'Property Location',
  'property-info.about-rooms': 'Rooms',
  'property-info.about-sites': 'About Sites',
  'property-info.special-emergencies': 'Emergencies',
  'property-info.gallery': 'Gallery',
  'property-info.policies': 'Policies',
  'property-info.nearby': 'Nearby',
  'property-info.transport': 'Transport',
  'property-info.location': 'Location',
  'property-info.about-rhproperty': 'About Retirement Home',
  'property-info.related-topics': 'Related Topics',
  'property-info.assistant-options': 'Welcome Message',
  'property-info.restaurant-assistant-information': 'Restaurant Information',
  'property-info.restaurant-assistant-options': 'Welcome Message',
  'property-info.channel-messages': 'Channel Messages',
  'property-info.icon.gallery': 'Icon Library',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Home Information',
  'property-info.loction': 'Locations',
  'property-info.rooms-and-images': 'Rooms & Images',
  'property-info.trainig-data': 'AI Training Data',
  'property-info.publishMonitor': 'Publish & Monitor',
  'property-info.webWidget': 'Web Widget',
  'property-info.media': 'Media',
  'property-info.flows': 'Flows',
  'property-info.add-your-own': 'Add Your Own',
  'property-info-utility-miscellaneous': 'Miscellaneous',
  'property-info-utility-payment': 'Payments',
  'property-info-utility-broadband': 'Broadband',
  'property-info-utility-emergency': 'Emergency',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'Moving',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Rate Plans',
  'rate-promo.rate-plan-addons': "Add-on's",
  'rate-promo.rate-plan-promos': 'Promos',

  'title.property-information': 'Property Information',

  'property.message': 'Message',
  'property.example': 'Example',
  'property.link': 'Links',
  'property.image-carousel': 'Image Carousel',
  'property.Title': 'Title',
  'property.SubTitle': 'Sub Title',

  'property.add-invoke-api': 'Invoke API',
  'property.add-message-button': 'Add Messages',
  'property.add-img-button': 'Add Images',
  'property.add-link-button': 'Add Link',

  'property.add-herocard-button': 'Add Hero Card',
  'property.add-api-button': 'Add Buttons',

  'menu.settings': 'Settings',
  'menu.workflows': 'Workflows',
  'menu.product_services': 'Products & Services',
  'menu.product_recommander': 'Product Recommender',
  'menu.digital_guide_book': 'Digital Guide Book',
  'menu.welcome_message': 'Welcome Message',
  'menu.about-property': 'About Property',
  'menu.property-facilities': 'Property Facilities',
  'menu.room-amenities': 'Room Amenities',
  'menu.property-contact': 'Propery Contact',
  'menu.about-rooms': 'Rooms',
  'menu.special-emergencies': 'Emergencies',
  'menu.show-filter': 'Filters',
  'menu.new': 'New',
  'menu.channel': 'Channels',
  'menu.application': 'Applications',

  'dashboards.send': 'Send',
  'dashboards.hello': 'Hello',
  'dashboards.notificationsAllowed': 'Notifications Allowed',
  'dashboards.allowNotifications': 'Allow Notifications',
  'dashboards.views': 'Views',
  'dashboards.bookingURL': 'Booking URL',
  'dashboards.searchTags': 'Search Tags',
  'dashboards.searchCategoryTags': 'Search Category Tags',
  'dashboards.bedroom': 'Bedroom',
  'dashboards.addBedroom': 'Add Bedroom',
  'dashboards.frequency': 'Frequency',
  'dashboards.includeSubpages': 'Include Subpages',
  'dashboards.enableFaqs': "Enable FAQ's",
  'dashboards.faqsDescription': "Enabling FAQs allows you to input questions while the system extracts corresponding answers from the Web Page content to create complete FAQs",
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Delete Document',
  'dashboards.confirmDelete': 'Are you sure you want to delete?',
  'dashboards.addItem': 'Add Item',
  'dashboards.addFirstWebPage': 'Add Your First Web Page',

  'dashboards.popular-compendium': 'Popular Compendium Menu Items',
  'dashboards.wordcloudofcompendium': 'Word Cloud of Compendium Menu Item',
  'dashboards.wordcloudonthings': 'Word Cloud on Things Website Visitors Are Asking About & Menu Items',
  'dashboards.common-asked': 'Commonly Asked Questions',

  'dashboards.website-visitor-asking':
    'Things callers are asking about',
  'dashboards.visit-country': 'Website Visit by Country',
  'dashboards.visit-traffic': 'Country Of The Website Traffic',
  'dashboards.rooms-product': 'Rooms & Products',
  'dashboards.popular-room-product': 'Popular rooms and products',

  'dashboards.messenger-stats': 'Popular Menu Items',
  'dashboards.messenger-stats-topic-view': 'Stats on Menu Item Views',
  'dashboards.messenger-stats-visits': 'Menu Item Views',
  'dashboards.opening-menu-items':
    'Number of Website Visitors opening Menu Items',

  'dashboards.number-totalavatarclick': 'Total Avatar Clicks',

  'dashboards.clicks': 'Clicks',
  'dashboards.leads': 'Leads',
  'dashboards.hours': 'Hours',
  'dashboards.minutes': 'Minutes',
  'dashboards.connect': 'Connect',
  'dashboards.ai-chatbot': 'AI Chatbot',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Digital Compendium Usage',
  'dashboards.compendium-unique-visits': 'QR code scans/clicks',
  'dashboards.compendium-opening-menu-items': 'Number of menu items viewed',
  'dashboards.compendium-total-digital-clicks':
    'Total Menu Item Views',
  'dashboards.compendium-total-qr-code': 'Total QR code Scans/Clicks',
  'dashboards.compendium-avg-menu-items': 'Avg Menu Item Views Per Scan',

  'property.delete': 'Delete',
  'menu.userroles': 'Users & Roles',
  'menu.members': 'Members',
  'menu.guest-pass': 'Guests Pass Outlets',
  'menu.ratebookings': 'Rates & Bookings',
  'dashboards.engagement-time': 'Digital Assistant Engagement Time',
  'dashboards.conversations-minutes':
    'Total Minutes & Overnight (7pm to 7am) Conversations Minutes',
  'dashboards.visitor-questions': 'Visitor Questions',
  'dashboards.recent-queries': 'Recent Queries',
  'dashboards.visitor-saying':
    'What your callers are talking about',
  'dashboards.contacts-prechatform-leavemessage':
    'Stored Contacts from Pre Chat Form & Leave Message',
  'menu.dashboards': 'Insights',
  'menu.ari': 'Availability & Rates',
  'menu.conversations': 'Conversations',
  'menu.conversations.unified-inbox': 'Unified Inbox',
  'menu.conversations.active': 'Agent Assist',
  'menu.conversations.archives': 'Archives',
  'menu.conversations.missed-responses': 'Missed Responses',
  'menu.conversations.ticket': 'Tickets',
  'menu.conversations.reply-templates': 'Reply Templates',
  'menu.bookings': 'Reservations & Bookings',
  'menu.tickets': 'Leads & Tickets',
  'menu.propinfo': 'Knowledge Hub',
  'menu.rate-promos': 'Rates & Promotions',
  'menu.finance': 'Finance',
  'menu.integration': 'Connect',
  'menu.admin': 'Admin & Security',
  'menu.favourites': 'Favourites',
  'menu.recommender': 'Conversation Flows',
  'menu.assistant-setup': 'Assistant Setup',
  'menu.admin-insights': 'Admin Insights',
  'menu.super-admin': 'Super Admin',
  'menu.groups': 'Groups',
  'menu.properties': 'Properties',
  'menu.service-provider': 'Service Providers',
  'menu.spaces': 'Spaces',
  'menu.content-manager': 'Content Manager',
  'menu.events-calendar': 'Events Calendar',
  'menu.appearance-settings': 'Appearance & Settings',
  'menu.help': 'Help',
  'menu.availability': 'Availability',
  'menu.myAccounts': 'My Accounts',
  'menu.guest-messaging': 'Guest Messaging',
  'guest-messaging.settings': 'Settings',
  'guest-messaging.outreach-setup': 'Outreach Setup',
  'guest-messaging.reservations': 'Reservations',
  'guest-messaging.insights_logs': 'Insights & Logs',
  'guest-messaging.settings.placeholder': 'Configure guest messaging preferences.',
  'guest-messaging.outreach.placeholder': 'Set up outreach campaigns and templates.',
  'guest-messaging.reservations.placeholder': 'Manage reservation-related messaging.',
  'guest-messaging.placeholder': 'Guest Messaging module coming soon.',
  'guest-messaging.reservation-source': 'Reservation Data Source',
  'guest-messaging.communication-channels': 'Communication Channels',
  'guest-messaging.templates': 'Templates',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Business Profile',

  'dashboards.tickets-by-category': 'Tickets by Category',
  'dashboards.download': 'Download',
  'dashboards.space-booking': 'Space Booking',
  'dashboards.gift-voucher': 'Gift Vouchers',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'From',
  'dashboards.to': 'To',
  'dashboards.active-groups': 'Active Groups',
  'dashboards.active-properties': 'Active Properties',
  'dashboards.live-properties': 'Live Properties',
  'dashboards.properties-going': 'Properties going live by date range',
  'dashboards.start-date': 'Start Date',
  'dashboards.end-date': 'End Date',
  'dashboards.all-properties-with': 'All properties with Live status',
  'dashboards.aibot-by-country': 'AI Chatbot Clients by Country',
  'dashboards.list-live-clients': 'List of live clients using AI Chatbot',
  'dashboards.subscribe-to-reports': 'Subscribe to Reports',
  'dashboards.website-visits': 'Website Visits',
  'dashboards.unique-visitors': 'Unique Visitors',
  'dashboards.last-week': 'Last Week',
  'dashboards.this-week': 'This Week',
  'dashboards.this-month': 'This Month',
  'dashboards.previous-month': 'Previous Month',
  'dashboards.yeartodate': 'Year to Date',
  'dashboards.lastyear': 'Last Year',
  'dashboards.last-7-days': 'Last 7 Days',
  'dashboards.last-30-days': 'Last 30 Days',
  'dashboards.last-60-days': 'Last 60 Days',
  'dashboards.last-90-days': 'Last 90 Days',
  'dashboards.conversion-rates': 'Conversion Rates',
  'dashboards.digital-assistant-engagement': 'Digital Assistant Engagement',
  'dashboards.total-overnight-conversations':
    'Total & Overnight (7pm to 7am) Conversations',
  'dashboards.percentage-accuracy': 'Understanding Accuracy',
  'dashboards.percentage-conversion': 'Website Traffic to Chat Conversion',
  'dashboards.percentage-avatarclick': 'Website Traffic to Avatar Clicks',
  'dashboards.percentage-negativefeedback':
    'Negative Feedback as a %age of Avatar Clicks',
  'dashboards.percentage-amenties': 'Amenity Queries',
  'dashboards.percentage-booking': 'Booking Enquiries',
  'dashboards.percentage-webchats': 'Website Chats',
  'dashboards.percentage-facebookchat': 'Facebook Chats',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'Total Conversation Time',
  'dashboards.number-totalconversation': 'Total Conversations',
  'dashboards.number-averagetimeconversation': 'Average Time Per Conversation',
  'dashboards.number-websiteconversation': 'Website Conversations',
  'dashboards.number-facebookconversation': 'Facebook Conversations',
  'dashboards.number-estimatedtimesaving': 'Estimated Time Savings',
  'dashboards.number-googlemapsconversation': 'Google Maps Conversations',
  'dashboards.number-whatsappconversation': 'WhatsApp Conversations',
  'dashboards.number-instagramconversation': 'Instagram Conversations',
  'dashboards.number-agentconversation': 'Agent Conversations',
  'dashboards.number-amenityqueries': 'Amenity Queries',
  'dashboards.number-bookingenquiries': 'Booking Queries',
  'dashboards.number-groupbookingenquiries': 'Group Booking Enquiries',
  'dashboards.number-eventenquiries': 'Event Enquiries',
  'dashboards.number-longstayenquiries': 'Long Stay Enquiries',
  'dashboards.number-totaltickets': 'Tickets',
  'dashboards.number-returncustomer': 'Return Customer',
  'dashboards.number-redirects': 'Website Redirects',
  'dashboards.number-bookingengineleads': 'Booking Engine Leads',
  'dashboards.number-roomnightsreferred': 'Room Nights Referred',
  'dashboards.number-revenuereferred': 'Revenue Referred',
  'menu.bookingsmenu': 'Bookings',
  'menu.guests': 'Guest Information',
  'menu.whatsnew': "What's New",

  'menu.formbuilder': 'Form Builder',
  'forms.forms-title': 'Form',
  "dashboards.trainAI": "Train AI with documents",
  "dashboards.uploadDocuments": "Upload documents to help your AI learn about your business and assist customers just as you would. You can add files in .doc, .pdf, or .txt.",
  'dashboards.welcomeMessage': 'Welcome Message',
  'dashboards.personalizeGreeting': 'Personalize the way customers are greeted to reflect your brand, style, and etiquette, ensuring they receive the warmest welcome. Customize greetings to reflect your brand and create a warm welcome.',
  'dashboards.addRoomDetails': 'Add details about each of your rooms so guests can easily discover everything they need to choose the perfect fit and make the booking process simpler and faster.',
  'dashboards.trainAIFAQs': 'Train AI with FAQs',
  'dashboards.manualQuestions': 'Some questions can’t be answered by documents or found on the website. Here, you can manually add questions to ensure customers always have the information they need at their fingertips.',
  'dashboards.publishAI': 'Publish AI to reflect the most recent updates',
  'dashboards.retrainAfterChanges': 'When you make changes in the Knowledge Hub or forms, be sure to retrain the chatbot on the updated information. Publishing your AI ensures the chatbot provides the most accurate and up‑to‑date answers.',
  'dashboards.enhanceKnowledge': 'Enhance AI knowledge by tracking unanswered queries',
  'dashboards.reviewUnanswered': 'Whenever the AI cannot answer a question or provides only limited detail, you’ll find those queries here. Review them to identify gaps in your Knowledge Hub or unique guest questions.',
  'dashboards.manageMedia': 'Manage Media',
  'dashboards.mediaGallery': 'Whenever you upload images such as rooms, amenities, logos, or your digital avatar, they will appear in this gallery, giving you a central place to manage visuals and ensure your guests see what makes your business unique.',
  'dashboards.createForms': 'Create forms easily and get notified on every submission.',
  'dashboards.manageForms': 'Create and manage forms to collect customer information, set up notifications, and customize them for different languages.',
  'dashboards.personalizeResponse': 'Personalize response style and how conversation progress',
  'dashboards.controlConversation': 'This advanced feature gives you the ability to shape and control how conversations unfold with your customers across different channels.',

  'menu.virtualfrontdesk': 'Virtual Front Desk',
  'menu.guestservice': 'Guest Services',
  'virtual-front.common-questions': 'Common Questions',
  'virtual-front.add-on-upsells': "Add-on's & Upsells",
  'virtual-front.service-order': 'Service Orders',
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'Digital Compendium',
  'virtual-front.outbound': 'Outbound',
  'virtual-messenger': 'Web Widget Menus',

  'missed-response.missed-response-title': 'Missed Response Title',
  //unified-inbox
  'content.allconversation': 'All Conversations',
  'content.active': 'Active',
  'content.tickets': 'Tickets',
  'content.filter': 'Filter',
  'content.createtickets': 'Create Tickets',
  'content.conversation': 'Conversation',
  'content.knowledgesearch': 'Knowledge Search',
  'content.reply': 'Reply',
  'content.visitorinfo': 'Visitor Info',
  'content.callinfo': 'Call Info',
  'content.allinsights': 'All Insights',
  'content.availabilityrates': 'Availability & Rates',
  'content.callback': 'Call Back',
  'content.close': 'Close',
  'content.sms': 'SMS',
  'content.timestamp': 'Timestamp',
  'content.topics': 'Topics',
  'content.callingparty': 'Calling Party',
  'content.accountdomain': 'Account Domain',
  'content.calledparty': 'Called Party',
  'content.recording': 'Recording',
  'content.phonesystemoriginationcallid': 'Phone System Origination Call ID',
  'content.phonesystemterminationcallid': 'Phone System Termination Call ID',
  'content.uniqueconversationid': 'Unique Conversation ID',
  'content.regenerateinsights': 'Regenerate Insights',
  'content.customersentiment': 'Customer Sentiment',
  'content.neutral': 'Neutral',
  'content.conversationinsights': 'Conversation Insights',
  'content.customeridverification': 'Customer ID Verification',
  'content.serviceactivationdate': 'Service Activation Date',
  'content.followups': 'Follow Up\'s',
  'content.actionneeded': 'Action needed',
  'content.uniqueConversationId': 'Unique Conversation ID',
  'content.uniqueChatId': 'Unique Chat ID',
  'content.recording&transcript': 'Recording & Transcript',
  'content.chatinsights': 'Chat Insights',
  'content.visitedpages': 'Visited Pages',
  'content.deviceinfo': 'Device Info',
  'content.chatstartedonthispage': 'Chat started on this page',
  'content.prechatinfo': 'Pre-chat Info',
  'content.notes': 'Notes',
  'content.reassign': 'Re-Assign',
  'content.open': 'Open',
  'content.dismiss': 'Dismiss',
  'content.add_placeholder': 'Add Placeholder values',
  'content.mobile_number': 'Mobile Number',
  'content.please_select': 'Please Select',
  'content.sendwhatsapp': 'Send WhatsApp Message',

  /*Missed-response */
  'feedback.missed-question': 'Missed Question',
  'feedback.conversation-summary': 'Conversation Summary',
  'feedback.dates-in-spanish': 'Dates need to be in Spanish',
  'feedback.resolve': 'Resolve',
  'feedback.ignore': 'Ignore',

  //integration
  'integration.select_properties': 'Select Properties',
  'integration.select_properties_enabled': 'Select the properties that are enabled through this integration',
  'integration.services_addons': 'Select Services & Add-on’s',
  'integration.services_visible': 'Select what services & Add-on’s that will be visible in this page',
  'integration.appearance': 'Appearance',
  'integration.appearance_customize': 'Choose your digital assistant\'s name, avatar and setup your colours',
  'integration.booking_calendar': 'Booking Calendar',
  'integration.booking_calendar_style': 'Choose styling for the booking calendar pop-up',
  'integration.nudges': 'Nudges',
  'integration.nudges_setup': 'Setup proactive messages to engage the website visitors',
  'integration.position': 'Position',
  'integration.position_control': 'Control the position of chat widget on your website',
  'integration.custom_fonts': 'Custom Fonts',
  'integration.custom_fonts_upload': 'Upload any custom fonts you might want to use for the page',
  'integration.custom_css': 'Custom CSS',
  'integration.custom_css_usage': 'Use CSS to customize your Digital Compendium',
  'integration.location': 'Location',
  'integration.location_embed': 'Add your embed location URL',
  'integration.external_links': 'External Links',
  'integration.external_links_add': 'Add your links',
  'integration.language': 'Language',
  'integration.widget_languages': 'Select the languages for the chat widget',
  'integration.chatbot_contact': 'Chatbot',
  'integration.chatbot_enable': 'Enable your digital assistant',
  'integration.chatbot_security': 'Keep your Messenger Secure',
  'integration.chatbot_trusted_pages': 'List your trusted pages to show Chatbot',
  'integration.chatbot_publish': 'Publish your digital assistant',
  'integration.chatbot_install': 'Copy the code snippet to install your digital assistant',

};
export default enMessages;